import { render } from "./unit-settings.vue?vue&type=template&id=0b5b8845"
import script from "./unit-settings.vue?vue&type=script&lang=js"
export * from "./unit-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__